import React from "react";
import { VendorLogoSvg } from "./VendorLoadingOverlay";
import "../styles/InlineLogoLoader.css";

function InlineLogoLoader({
  className = "",
  logoClassName = "",
  decorative = true,
  label = "Loading",
}) {
  return (
    <div
      className={`inline-logo-loader ${className}`.trim()}
      aria-hidden={decorative ? "true" : undefined}
      role={decorative ? undefined : "status"}
      aria-label={decorative ? undefined : label}
    >
      <VendorLogoSvg
        className={`inline-logo-loader-logo ${logoClassName}`.trim()}
      />
    </div>
  );
}

export default InlineLogoLoader;
